import { render, staticRenderFns } from "./courseMouldInfo.vue?vue&type=template&id=447a3451&scoped=true&"
import script from "./courseMouldInfo.vue?vue&type=script&lang=js&"
export * from "./courseMouldInfo.vue?vue&type=script&lang=js&"
import style0 from "./courseMouldInfo.vue?vue&type=style&index=0&id=447a3451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a3451",
  null
  
)

export default component.exports